import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const handler = ( $ ) => {
	gsap.registerPlugin( ScrollTrigger );

	const $statNumbers = $( '.stats-banner__stat-number' );

	if ( ! $statNumbers.length ) return;

	const animateNumberHandler = function () {
		const $thisStatNumber = $( this );
		const originalText = $thisStatNumber.text();

		// Extract prefix, number and suffix.
		const matches = originalText.match( /^([^0-9]*)([0-9,.]+)(.*)$/ );

		if ( ! matches ) return;

		const prefix = matches[ 1 ] || '';
		const numberPart = parseFloat( matches[ 2 ].replace( /,/g, '' ) );
		const suffix = matches[ 3 ] || '';

		// Set initial value
		$thisStatNumber.text( prefix + '0' + suffix );

		// Create an object for animation
		const obj = { value: 0 };

		gsap.to( obj, {
			scrollTrigger: {
				trigger: $thisStatNumber,
				start: 'top 80%',
				once: true,
			},
			value: numberPart,
			duration: 2,
			ease: 'power1.out',
			onUpdate: function () {
				const value = Math.round( obj.value );

				$thisStatNumber.text(
					prefix + value.toLocaleString() + suffix
				);
			},
		} );
	};

	$statNumbers.each( animateNumberHandler );
};

export default ( ( $ ) => $( handler ) )( jQuery );
